import { StockEndpoints } from '@/modules/inventory/stock/api/stockEndpoints'

/**
 * Stock endpoint instance
 * instantiate product api class with a different api path
 */

export const stockEndpoints = new StockEndpoints()
